module.exports = __webpack_public_path__ + "img/gold-star-icon.ea2a82af.png";